<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-01 02:16:12
    Description : gaia48页面header
  -->
  <div class="header-background">
    <div class="gaiamount" @click="jumpTo('/', true)">
      <span class="gaia">Gaia</span>mount
    </div>
    <div
      class="upload"
      @click="jumpTo('/desktop/gaia-48/upload', true)"
      style="border-radius: 4px 0 0 4px; border-right: none"
    >
      上传
    </div>
    <div
      class="upload"
      @click="jumpTo('http://gaiamount.mikecrm.com/VV6iRuZ')"
      style="margin: 0"
    >
      报名
    </div>
    <div class="header">
      <!-- <div class="gaiamount">返回 Gaiamount</div> -->
      <div class="logo">
        <img class="logo-img" :src="logo" @click="jumpTo2('/gaia-48/main')" />
      </div>
      <el-dropdown :hide-on-click="false" :key="0">
        <span class="el-dropdown-link">
          <div class="link-item">48小时</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/gaia-48/info?index=0">
            <el-dropdown-item> Gaia48 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/info?index=1">
            <el-dropdown-item> 竞赛细则 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/info?index=2">
            <el-dropdown-item> 奖项设置 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/info?index=3">
            <el-dropdown-item> 评审团 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/info?index=4">
            <el-dropdown-item> 日程安排 </el-dropdown-item>
          </router-link>
          <router-link to="">
            <el-dropdown-item>
              <div @click="jumpTo('http://gaiamount.mikecrm.com/VV6iRuZ')">
                报名参赛
              </div>
            </el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="line">/</div>
      <el-dropdown :hide-on-click="false" :key="5">
        <span class="el-dropdown-link">
          <div class="link-item">展映</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/gaia-48/exhibit-region">
            <el-dropdown-item> 分站赛 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/exhibit-year">
            <el-dropdown-item> 年度获奖 </el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="line">/</div>
      <el-dropdown :hide-on-click="false" :key="1">
        <span class="el-dropdown-link">
          <div class="link-item">集训</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/gaia-48/introduce?index=0">
            <el-dropdown-item> 介绍 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/introduce?index=1">
            <el-dropdown-item> 线上集训 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/introduce?index=2">
            <el-dropdown-item> 线下集训 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/introduce?index=3">
            <el-dropdown-item> 公开课 </el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="line">/</div>
      <el-dropdown :hide-on-click="false" :key="2">
        <span class="el-dropdown-link">
          <div class="link-item">Party Night</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/gaia-48/party-night?index=0">
            <el-dropdown-item> 播映 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/party-night?index=1">
            <el-dropdown-item> 颁奖 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/party-night?index=2">
            <el-dropdown-item> 设备展 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/party-night?index=3">
            <el-dropdown-item> Party </el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="line">/</div>
      <el-dropdown :hide-on-click="false" :key="3">
        <span class="el-dropdown-link">
          <div class="link-item">发布</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/gaia-48/news?index=0">
            <el-dropdown-item> 官方发布 </el-dropdown-item>
          </router-link>
          <router-link to="/gaia-48/news?index=1">
            <el-dropdown-item> 相册 </el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="line">/</div>
      <el-dropdown :hide-on-click="false" :key="4">
        <span class="el-dropdown-link">
          <div class="link-item">···</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/gaia-48/download">
            <el-dropdown-item> 资源下载 </el-dropdown-item>
          </router-link>
          <router-link to="/richPage?type=6">
            <el-dropdown-item> 参赛协议 </el-dropdown-item>
          </router-link>
          <router-link to="/richPage?type=7">
            <el-dropdown-item> 成片要求 </el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="line">/</div>
      <!-- <div class="upload" v-if="isLogin">
        <img :src="uploadBtn" @click="$emit('upload')" />
      </div> -->
      <div
        class="avatar"
        v-if="isLogin"
        @mouseenter="avatarShow = true"
        @mouseleave="avatarShow = false"
      >
        <el-avatar :size="30" :src="avatar">
          <img :src="VUE_APP_DEFAULTAVATAR" />
        </el-avatar>
      </div>
      <div v-if="!isLogin" class="loginBox">
        <el-link :underline="false" @click="register"> 注册 </el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link :underline="false" @click="jumpTo('/account/login', true)">
          登录
        </el-link>
      </div>
    </div>
    <div
      class="dialog"
      v-show="avatarShow"
      @mouseenter="avatarShow = true"
      @mouseleave="avatarShow = false"
    >
      <div class="self-card">
        <el-avatar :size="60" :src="avatar">
          <img :src="VUE_APP_DEFAULTAVATAR" />
        </el-avatar>
        <div class="title">
          <div class="name">{{ nickname }}</div>
          <div class="job">{{ job }}</div>
        </div>
      </div>
      <el-divider></el-divider>
      <div style="display: flex; margin-bottom: 80px">
        <div
          class="icon-btn"
          @click="jumpTo('/account/private/userInfo', true)"
        >
          <i class="el-icon-user-solid"></i>
          <div>帐户管理</div>
        </div>
        <div class="icon-btn" @click="jumpTo(`/personal/index/${id}`, true)">
          <i class="el-icon-s-tools"></i>
          <div>创作管理</div>
        </div>
      </div>
      <div class="logout">
        <el-link :underline="false" style="width: 100%" @click="logout">
          退出登录
        </el-link>
      </div>
    </div>
  </div>
</template>

<script>
import shoppingCartItem from "@/components/shoppingCart-item/shoppingCart-item";
import {
  getWorksShoppingCartList,
  getCollegeShoppingCartList,
  getOrderShoppingCartList,
  getShoppingCartList,
} from "@/api/order";
export default {
  name: "gaia-header",
  components: {
    shoppingCartItem,
  },
  data() {
    return {
      logo: require("@/assets/images/gaia-48.png"),
      uploadBtn:
        "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/header_popup_ic_up_n.png",
      shoppingBtn:
        "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/header_popup_ic_bigcart_n.png",
      avatar: "",
      nickname: "",
      job: "",
      id: "",
      avatarShow: false,
      shopcartShow: false,
      time: null,
      VUE_APP_DEFAULTAVATAR: process.env.VUE_APP_DEFAULTAVATAR,
      VUE_APP_RESOURCES_URL: process.env.VUE_APP_RESOURCES_URL,
      shoppingList: [],
      isLogin: false,
    };
  },
  created() {
    // 判断是否登录
    let user = localStorage.getItem("user");
    if (user && document.cookie.includes("user_login_token")) {
      this.isLogin = true;
      user = JSON.parse(user);
      // console.log(user);
      this.avatar = this.VUE_APP_RESOURCES_URL + user.avatar;
      this.nickname = user.nickname;
      this.job = user.job;
      this.id = user.account.id;
      this.getShoppingCart();
    } else {
      this.isLogin = false;
      console.log("未登录");
    }
  },
  methods: {
    /**
     * 获取购物车商品, 包括作品 教程 会员
     */
    getShoppingCart() {
      const order = new Promise((resolve) => {
        getOrderShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const works = new Promise((resolve) => {
        getWorksShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const college = new Promise((resolve) => {
        getCollegeShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const material = new Promise((resolve) => {
        getShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      Promise.all([order, works, college, material]).then((res) => {
        const order = res[0].memberShoppingCart;
        const works = res[1].worksShoppingCartBOS;
        const college = res[2].courseShoppingCartBOS;
        const material = res[3].materialShoppingCarts;
        if (order) {
          this.shoppingList.push(order);
        }
        if (college) {
          college.map((el) => {
            this.shoppingList.push(el);
          });
        }
        if (works) {
          works.map((el) => {
            this.shoppingList.push(el);
          });
        }
        if (material) {
          material.map((el) => {
            this.shoppingList.push(el);
          });
        }
        // 冒泡排序, 根据添加时间排序
        const list = this.shoppingList;
        for (let j = 0; j < list.length; j++) {
          let done = true;
          let max = list.length - 1;
          for (let i = 0; i < max - j; i++) {
            if (
              new Date(list[i].createTime).valueOf() <
              new Date(list[i + 1].createTime).valueOf()
            ) {
              let temp = list[i];
              list[i] = list[i + 1];
              list[i + 1] = temp;
              done = false;
            }
          }
          if (done) {
            break;
          }
        }
        list.map((el, i) => {
          if (el.works) {
            list[i].name = el.works.title;
            if (el.works.cover) {
              list[i].cover = el.works.cover;
            } else {
              el.works.video.resources.map((el) => {
                if (el.resourceKey && el.resourceKey.includes("180.png")) {
                  list[i].cover = el.resourceKey;
                }
              });
            }
          } else if (el.course) {
            list[i].name = el.course.title;
            list[i].cover = el.course.cover;
          }
        });
        // log(JSON.parse(JSON.stringify(list)));
      });
    },
    /**
     * 非router跳转路由
     */
    jumpTo(url, self = false) {
      if (self) {
        location.href = url;
      } else {
        window.open(url);
      }
    },
    jumpTo2(url) {
      this.$router.push(url);
    },
    /**
     * 注册
     */
    register() {
      localStorage.setItem("way", "register");
      this.jumpTo("/account/login", true);
    },
    /**
     * 退出登录, 并且回到首页
     */
    logout() {
      document.cookie = "";
      localStorage.removeItem("user");
      this.jumpTo("/", true);
    },
  },
};
</script>

<style lang="less">
.header-background {
  position: fixed;
  width: 100%;
  min-width: 1300px;
  height: 88px;
  background: #ffffff;
  // box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  z-index: 100;
}
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}

.el-dropdown-menu__item:hover {
  color: #ffffff !important;
  background: #fd9009 !important;
}
.el-dropdown-menu {
  border: none;
}
</style>
<style lang="less" scoped>
.gaiamount {
  display: inline-block;
  width: 110px;
  margin: 16px 0 0 61vw;
  border-radius: 4px;
  padding: 3.6px 6px;
  font-size: 12px;
  font-weight: bold;
  color: #000000;
  background: #ececec;
  text-align: center;
  cursor: pointer;
  transition: 0.4s all;
}
.gaia {
  color: #ff464c;
  transition: 0.4s all;
}
.gaiamount:hover {
  color: #ffffff;
  background: #ff464c;
  transition: 0.4s all;
  > .gaia {
    color: #ffffff;
  }
}
.upload {
  display: inline-block;
  width: 50px;
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 0px 4px 4px 0px;
  margin-left: 20px;
  text-align: center;
  color: #ffa100;
  border: solid 1px #ffa100;
  cursor: pointer;
  transition: 0.4s all;
}
.upload:hover {
  background: #ffa100;
  color: #ffffff;
  transition: 0.4s all;
}
a {
  text-decoration: none;
  color: #333333;
}
.header {
  display: flex;
  align-items: center;
  width: 1300px;
  height: 50px;
  left: 0;
  right: 0;
  padding: 2px 50px;
  padding-top: 18px;
  margin: -10px auto 0;
  background: #ffffff;
  box-sizing: border-box;
  z-index: 100;
}
.logo {
  display: flex;
  width: 447px;
  .logo-img {
    display: block;
    width: 128px;
    height: 29px;
    margin-top: -28px;
    cursor: pointer;
  }
  .title {
    color: #717171;
    font-size: 12px;
    padding: 4px 15px;
  }
}
.link-item {
  margin: 0px 20px;
  height: 56px;
  line-height: 56px;
  color: #000000;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
.link-item:hover {
  border-bottom: solid 4px #ffa200;
}
.avatar {
  margin: 0 40px;
  text-align: center;
  cursor: pointer;
}
.shopping {
  cursor: pointer;
}
.dialog {
  position: absolute;
  top: 52px;
  right: 10%;
  width: 410px;
  height: auto;
  background: #ffffff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  padding: 20px 20px 0;
  box-sizing: border-box;
  z-index: 10000;
}
.self-card {
  display: flex;
  align-items: center;
  margin-top: 20px;
  .title {
    margin-left: 20px;
    color: #333;
    font-weight: 700;
    font-size: 16px;
    .name {
      height: 30px;
    }
    .job {
      color: #999;
      font-size: 14px;
    }
  }
}
.loginBox {
  width: 220px;
  text-align: right;
  .el-link--inner {
    font-size: 12px;
  }
}
.logout {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 36px;
}
.icon-btn {
  text-align: center;
  width: 16%;
  font-size: 14px;
  color: #666;
  margin-right: 24%;
  cursor: pointer;
  i {
    font-size: 40px;
    margin-bottom: 10px;
    color: #999999;
  }
}
.shopping-card {
  .list {
    height: 480px;
  }
  .item {
    color: #999999;
    margin: 10px 0;
    width: 100%;
    cursor: pointer;
    i {
      font-size: 24px;
    }
    span {
      font-weight: 700;
      color: #616161;
      font-size: 14px;
      margin-left: 10px;
    }
    .el-icon-arrow-right {
      float: right;
      font-size: 20px;
      margin-top: 6px;
    }
  }
  .shopping-none {
    font-size: 14px;
    color: #666;
    padding: 20px;
  }
}
.line {
  padding: 0 2px;
  color: #ffa100;
  font-weight: 300;
}
.line-2 {
  width: 0;
  margin-left: 10px;
  border-left: solid 4px #ffa100;
}
</style>
